import React from 'react';
import { useStyletron } from 'baseui';
import { Button } from 'baseui/button';
import { Plus } from 'baseui/icon';

interface FloatingActionButtonProps {
	onClick: () => void;
}

const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({ onClick }) => {
	const [css] = useStyletron();

	return (
		<div
			className={css({
				position: 'fixed',
				bottom: '24px',
				right: '24px',
				zIndex: 1000
			})}>
			<Button
				onClick={onClick}
				size='large'
				shape='round'
				overrides={{
					BaseButton: {
						style: {
							width: '64px',
							height: '64px',
							borderRadius: '50%',
							backgroundColor: '#27ae60',
							boxShadow: '0 8px 24px rgba(39, 174, 96, 0.3)',
							transition: 'all 0.2s ease',
							':hover': {
								backgroundColor: '#229954',
								boxShadow: '0 12px 32px rgba(39, 174, 96, 0.4)',
								transform: 'translateY(-2px)'
							},
							':active': {
								transform: 'translateY(0px)'
							}
						}
					}
				}}>
				<Plus size={24} />
			</Button>
		</div>
	);
};

export default FloatingActionButton;
